const setUserCredentials = (state, payload) => {
    state.user = payload;
};
const setFaq = (state, payload) => {
    state.faq = payload;
};
const setNotificationList = (state, payload) => {
    state.notification = payload;
};
const setMyCourses = (state, payload) => {
    state.myCourses = payload;
};
const setCertificates = (state, payload) => {
    state.certificates = payload;
};
const setCertificateCheckInfo = (state, payload) => {
    state.certificateCheckInfo = payload;
};
const setCertificated = (state, payload) => {
    state.certificated = payload;
};
const setCertificatedData = (state, payload) => {
    state.certificatedData = payload;
};
const setBranches = (state, payload) => {
    state.branches = payload;
};
export default {
    setUserCredentials,
    setFaq,
    setMyCourses,
    setNotificationList,
    setCertificates,
    setCertificateCheckInfo,
    setCertificated,
    setCertificatedData,
    setBranches,
};